var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8479 9.34799C12.8565 9.57541 11.8235 9.54726 10.8459 9.2662C9.86835 8.98513 8.97817 8.46035 8.25891 7.74109C7.53965 7.02182 7.01487 6.13165 6.7338 5.15406C6.45274 4.17647 6.42459 3.1435 6.65201 2.15206L6.65193 2.15204C5.60814 2.39282 4.64782 2.90862 3.8707 3.64589C3.09357 4.38315 2.52797 5.315 2.23261 6.34469C1.93725 7.37437 1.92291 8.46435 2.19107 9.50145C2.45923 10.5385 3.00012 11.485 3.75758 12.2424C4.51503 12.9999 5.46144 13.5408 6.49854 13.8089C7.53564 14.0771 8.62561 14.0628 9.6553 13.7674C10.685 13.472 11.6168 12.9064 12.3541 12.1293C13.0914 11.3522 13.6072 10.3919 13.848 9.34808L13.8479 9.34799Z",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeping);
export default __webpack_public_path__ + "static/media/sleeping.eb3e063d8d02c4e320d233031dccedcc.svg";
export { ForwardRef as ReactComponent };